import { useState, useContext } from "react";
import { useHistory, Link } from "react-router-dom";

import { CompanyContext } from "../../Store/CompanyContext";
import { MdErrorOutline } from "react-icons/md";
import { signin } from "../../API/Login/login";
import Loading from "../../Components/Loading/Loading";
import { MydnaLogo } from "../../Icons/logo";
import { ComputerMessageIcon } from "../../Icons/Icons";

import { getCandidateInfo } from "../../API/Candidates/Cadidate";
import { EmployerContext } from "../../Store/EmployerContext";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Swal from "sweetalert2";

import "./login.sass";

const Login = () => {
  const { actions } = useContext(CompanyContext);
  const { actions: employerActions, store: employerStore } = useContext(EmployerContext);
  const [value, setValue] = useState(employerStore.language === "ES" ? "ES" : "PT-BR");
  const history = useHistory();
  const language = employerStore.language === "ES" ? "ES" : "PT-BR";
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    setError(false);
    setUser({
      ...user,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const changeLanguage = (e) => {
    const language = e === "ES" ? "ES" : "PT-BR";
    employerActions.setLanguage(language);
  };

  const handleSelect = (e) => {
    setValue(e);
  };

  const handleLogin = async () => {
    setLoading(true);
    const auth = await signin(user);

    if (auth && auth.response?.roleId === 3) {
      const userStage = await getCandidateInfo(auth?.response?.candidateId);

      setError(false);
      localStorage.setItem("token", auth.token);
      localStorage.setItem("user", JSON.stringify(auth.response));
      localStorage.setItem("email", JSON.stringify(user.email));
      localStorage.setItem("candidateId", JSON.stringify(auth.response.candidateId));

      changeLanguage(language);

      const bringElementsForToken = user.email + ":" + user.password;
      const hash = window.btoa(bringElementsForToken);
      localStorage.setItem("hash", hash);

      actions.setLogin(auth.response);
      if (userStage?.item?.registration_stage !== "Finished" || userStage?.item?.registration_stage === null || !userStage?.item?.registration_stage) {
        history.push("candidate/first-login");
      } else {
        history.push("/candidate");
      }
    } else {
      setLoading(false);
      setError(true);
    }
  };

  return (
    <>
      <div className="login d-none d-lg-block">
        {loading && <Loading textShow={false} />}
        <div className="d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
          <div className="col-6 me-5">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center mb-3">
                <img alt="" style={{ maxWidth: "200px" }} className="companyLogo img-fluid mb-2" src={`https://assets.mydna.company/logo-black-MyDNA.png`} />
                <span className="ms-2">| {language === "PT-BR" ? "Portal de Carreira" : "Portal de Carrera"}</span>
              </div>
              <div className="">
                <DropdownButton className="custom-dropdown-login rounded-pill" size="sm" title={value} onSelect={handleSelect}>
                  <Dropdown.Item eventKey="ES" onClick={() => employerActions.setLanguage("ES")}>
                    ES
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="PT" onClick={() => employerActions.setLanguage("PT-BR")}>
                    PT
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
            {/* <h2>{loginTranslate.textLogin}</h2> */}
            <h2 style={{ color: "#8574F1", fontSize: 24, marginBottom: 16 }}>Log-in</h2>
            <div className="group-input mb-2">
              <div className="span">Email</div>
              <input className="px-2 py-3 rounded" style={{ marginTop: 4 }} placeholder="Email" type="text" name="email" value={user.email} onChange={handleChange} />
            </div>
            <div className="group-input">
              <div className="span">{language === "PT-BR" ? "Senha" : "Contraseña"}</div>
              <input
                className="px-2 py-3 rounded"
                style={{ marginTop: 4 }}
                placeholder={language === "PT-BR" ? "Senha" : "Contraseña"}
                type="password"
                name="password"
                value={user.password}
                onChange={handleChange}
              />
              {error && (
                <span className="error">
                  <MdErrorOutline size={18} /> {language === "PT-BR" ? "Nome de Usuário ou Senha incorreta!" : "Nombre de Usuario o Contraseña incorrecta!"}
                </span>
              )}
            </div>
            <div className="content-button">
              <button className="rounded mt-4" onClick={handleLogin} style={{ width: "100%" }}>
                {language === "PT-BR" ? "Iniciar Sessão?" : "Iniciar Sesión"}
              </button>
            </div>
            <div className="mt-4">
              <span className="me-2">{language === "PT-BR" ? "Não tem uma conta?" : "¿Aún no tienes una cuenta?"}</span>
              <Link to="/signup">{language === "PT-BR" ? "Criar nova conta" : "Crear nueva cuenta"}</Link>
            </div>
          </div>
          <div className="col-6 d-flex justify-content-center align-items-center">
            <img src={`${process.env.REACT_APP_API_STORAGE}banner-login-candidate.png`} alt="Imagem" style={{ maxWidth: "100%", maxHeight: "100%" }} />
          </div>
        </div>
      </div>
      <div className="mobile container d-lg-none">
        <div className="row justify-content-center">
          <div className="col-auto text-center pt-5">
            <ComputerMessageIcon width={65} height={65} color={"#444258"} />
          </div>
          <div className="col-auto text-center py-5 my-2">
            <h3 className="fw-bold color-grey">{language === "PT-BR" ? "Prezado usuário" : "Estimado usuario"}</h3>
            <h5 className="color-grey">
              {language === "PT-BR"
                ? "Para obter a melhor experiência, você deve acessar o MyDNA de um computador ou notebook."
                : "Para tener la mejor experiencia, debes acceder a MyDNA desde una computadora o notebook."}
            </h5>
          </div>
          <div className="col-12 text-center">
            <MydnaLogo size={220} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
